import { toast } from "react-toastify";
import { Icon } from "../../components/icon/icon";
import { ChangePasswordModal } from "../../components/modal/app_modals/changePasswordModal";
import { BgWrapper } from "../../components/wrapper/bgWrapper";
import { useModalControl } from "../../customeHooks/useModalControl";
import { useGetUserProfileQuery } from "../../redux/features/auth/auth.api";
import { useAppSelector } from "../../redux/hooks";
import { formatDate } from "../../utils/helpers";

export const SecuritySettings = () => {
  const { profile, isSignedIn } = useAppSelector((state) => state.auth);

  const { refetch: refetchProfile } = useGetUserProfileQuery(
    { id: profile?._id ?? "" },
    {
      skip: !isSignedIn,
    },
  );

  const { modal, modalOpen, handleModalClose, handleModalOpen } =
    useModalControl();

  return (
    <>
      <BgWrapper
        className="flex cursor-pointer items-center gap-3"
        onClick={() => {
          handleModalOpen("changePasswordModal");
        }}
      >
        <Icon svg="padlock" width={20} height={20} />

        <div className="flex-1">
          <p className="text-base font-bold text-black">Change Password</p>
          <p className="text-sm text-grey-500">
            Last changed on{" "}
            {formatDate(
              profile?.lastPasswordChangeDate ?? "",
              "DD MMM, YYYY • h:mm A",
            )}
          </p>
        </div>

        <Icon
          svg="caret-down"
          width={20}
          height={20}
          className="-rotate-90 text-grey-600"
        />
      </BgWrapper>

      <ChangePasswordModal
        onSuccess={async () => {
          handleModalClose();
          toast.success("Password Changed");
          await refetchProfile();
        }}
        open={modalOpen && modal === "changePasswordModal"}
        handleClose={() => {
          handleModalClose();
        }}
      />
    </>
  );
};
